export default __webpack_public_path__ + "static/media/white_ayit_digital_logo.d366e8c1.png";